import { AnimatePresence, motion } from 'framer-motion';
import { Info } from 'lucide-react';

export const MinimumDurationPopup = ({ showMinimumInfo, setShowMinimumInfo, requiredSlots }) => {
  if (!showMinimumInfo) return null;

  return (
    <AnimatePresence>
      {showMinimumInfo && (
        <motion.div
          initial={{ opacity: 0, y: -20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -20, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="absolute -top-24 left-1/2 transform -translate-x-1/2 z-40"
        >
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl shadow-xl px-5 py-4 flex items-center gap-3 w-auto">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <Info className="w-5 h-5 text-blue-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-blue-900 mb-1">
                Please select at least {requiredSlots} consecutive time slots
              </p>
              <p className="text-xs text-blue-700">
                Minimum booking duration is 1 hour to proceed
              </p>
            </div>
            <button
              onClick={() => setShowMinimumInfo(false)}
              className="text-blue-400 hover:text-blue-600 transition-colors ml-2"
            >
              {/* <XCircle className="w-5 h-5" /> */}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};